import type { HostBridge, HostBridgeMessage } from "./hostBridge";
import { clearSetupThrottle } from "@/betby/viewmodels/useBetbyRendererViewModel";

export interface HostBridgeCallbacks {
  onTokenExpired?: (message?: string, title?: string) => void;
  onRecharge?: () => void;
  onBack?: () => void;
  onLogin?: () => void;
  onCurrencyChange?: (currency: "sc" | "gc") => void;
  onGetWallet?: () => void;
  onUrlChange?: (url: string) => void;
  onNavigate?: (url: string) => void;
  /** Request new session ticket from host (returns Promise with ticket or null) */
  onRequestSessionTicket?: () => Promise<string | null>;
}

function dispatchMessage(
  callbacks: HostBridgeCallbacks,
  message: HostBridgeMessage,
): boolean {
  switch (message.type) {
    case "LoggedOut": {
      const payload =
        message.data &&
        typeof message.data === "object" &&
        !Array.isArray(message.data)
          ? (message.data as {
              action?: string;
              message?: string;
              title?: string;
            })
          : undefined;

      if (payload?.action === "tokenExpired") {
        clearSetupThrottle();
        callbacks.onTokenExpired?.(payload.message, payload.title);
        return true;
      }

      clearSetupThrottle();
      callbacks.onBack?.();
      return true;
    }
    case "TurnShop":
      callbacks.onRecharge?.();
      return true;
    case "SDKLogin": {
      console.log("33333333", 4444444);
      callbacks.onLogin?.();
      return true;
    }
    case "MoneyType": {
      const moneyTypeValue = Array.isArray(message.data)
        ? message.data[0]
        : undefined;
      const currency =
        moneyTypeValue === 1 ? "gc" : moneyTypeValue === 0 ? "sc" : undefined;
      if (currency) {
        callbacks.onCurrencyChange?.(currency);
      }
      return true;
    }
    case "GetWallet":
      callbacks.onGetWallet?.();
      return true;
    case "BetbyNavigate":
      callbacks.onNavigate?.(message.data.url ?? "");
      return true;
    case "BetbyUrlChange":
      callbacks.onUrlChange?.(message.data.url ?? "");
      return true;
    default:
      return false;
  }
}

export function createCallbackHostBridge(
  callbacks: HostBridgeCallbacks,
): HostBridge {
  return {
    postMessage(message) {
      console.log("betby-event ", "postMessage ", message);
      return dispatchMessage(callbacks, message);
    },
    sendBack() {
      console.log("betby-event ", "sendBack ");
      clearSetupThrottle();
      callbacks.onBack?.();
      return true;
    },
    sendRecharge() {
      console.log("betby-event ", "sendRecharge ");
      callbacks.onRecharge?.();
      return true;
    },
    sendLogin() {
      console.log("betby-event ", "sendLogin ");
      clearSetupThrottle();
      callbacks.onLogin?.();
      return true;
    },
    sendTokenExpired(message, title) {
      console.log(
        "betby-event ",
        "sendTokenExpired ",
        "message ",
        message,
        "title ",
        title,
      );
      clearSetupThrottle();
      callbacks.onTokenExpired?.(message, title);
      return true;
    },
    sendCurrencyChange(currency) {
      console.log("betby-event ", "sendCurrencyChange ", currency);
      clearSetupThrottle();
      callbacks.onCurrencyChange?.(currency);
      return true;
    },
    sendGetWallet() {
      console.log("betby-event ", "sendGetWallet ");
      callbacks.onGetWallet?.();
      return true;
    },
    sendNavigate(url) {
      console.log("betby-event ", "sendNavigate ", url);
      callbacks.onNavigate?.(url);
      return true;
    },
    sendUrlChange(url) {
      console.log("betby-event ", "sendUrlChange ", url);
      callbacks.onUrlChange?.(url);
      return true;
    },
    async requestSessionTicket() {
      console.log("betby-event ", "requestSessionTicket");
      clearSetupThrottle();
      return callbacks.onRequestSessionTicket?.() ?? null;
    },
  };
}
